// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-9b9b8ed8] {\n  width: 100%;\n  text-align: left;\n  font-size: 1.5em;\n}\n.company-page[data-v-9b9b8ed8], .filter-block[data-v-9b9b8ed8] {\n  width: 100vw;\n  margin: 0;\n}\n.card[data-v-9b9b8ed8] {\n  border-radius: 15px !important;\n}", ""]);
// Exports
module.exports = exports;
